import { IntakeRequestType } from '../types';
// configs to maintain order

export const IntakeRequestTypeOnBoardIdp = [
  { key: 'appName', label: 'Application name' },
  { key: 'idpType', label: 'IdP type' },
  { key: 'contactEmails', label: 'Contact emails' },
];

export const IntakeRequestTypeAdoptSsoApp = [
  { key: 'appName', label: 'Application name' },
  { key: 'appType', label: 'Application type' },
];

export const IntakeRequestTypeIntegrateApi = [
  {
    key: 'exposeApiViaGateway',
    label: 'Do You Want Your API To Be Exposed VIA DXM Gateway',
  },
  { key: 'apiSpecUris', label: 'Open API Specification Links' },
  { key: 'apiSpecFiles', label: 'Upload Open API Specification Files' },
  {
    key: 'supportTeamEmails',
    label: 'What Is The Support Team Email Address For This API',
  },
  {
    key: 'loadTestingConsent',
    label: 'Do You Agree To Participate In Load Testing',
  },
  { key: 'dxmAuthorizationLayer', label: 'DXM Authorization Layer' },
  {
    key: 'apiSpecVisibilityScope',
    label: 'API Specification Visibility Scope',
  },
  { key: 'apiBaseUrls', label: 'API Base URLs' },
  { key: 'environmentMapping', label: 'Environment Mapping' },
  { key: 'authenticationDetails', label: 'Authentication Details' },
  { key: 'tokenValidationLocation', label: 'Token Validation Location' },
  {
    key: 'currentAuthorizationApproach',
    label: 'Current Authorization Approach',
  },
  { key: 'corsConfiguration', label: 'CORS Configuration' },
  {
    key: 'responsibleContacts',
    label: 'Who Are The Responsible Team Members For This Integration',
  },
  { key: 'additionalNotes', label: 'Additional Notes' },
  { key: 'gatewayBasePath', label: 'Gateway Base Path' },
];

export const IntakeRequestTypeSsoConnector = [
  { key: 'issuer', label: 'Issuer' },
  { key: 'clientId', label: 'Client ID' },
  { key: 'clientSecret', label: 'Client Secret' },
];

export const getIntakeRequestTypeFields = (requestType: IntakeRequestType) => {
  switch (requestType) {
    case IntakeRequestType.OnBoardIdp:
      return IntakeRequestTypeOnBoardIdp;
    case IntakeRequestType.AdoptSsoApp:
      return IntakeRequestTypeAdoptSsoApp;
    case IntakeRequestType.IntegrateApi:
      return IntakeRequestTypeIntegrateApi;
    case IntakeRequestType.Oidc:
    case IntakeRequestType.Saml:
      return IntakeRequestTypeSsoConnector;
    default:
      return [];
  }
};
